export default "__VITE_ASSET__DcAKQ97F__"